import React from "react"

function Main(props){
    let value = props.listData
    return(
        <div className="main">
            <div className="container">
                <div id="sort">

                </div>
                <div id={"sort2"}>

                </div>
            </div>
        </div>
    )
}


export default Main